import { MissingKeyError } from '../errors';
import { converteValueToType } from '../util';
export class DotAccessor {
    constructor(data) {
        this.data = data;
        if (!data) {
            // TODO
        }
    }
    has(key) {
        return typeof this.data === 'object' && key in this.data;
    }
    get(key, defaultValue) {
        if (arguments.length === 2) {
            if (!this.has(key)) {
                return defaultValue;
            }
        }
        else {
            this._assertHasKey(key);
        }
        return new DotAccessor(this.data[key]);
    }
    list(key, defaultValue) {
        if (!this.hasKey(key)) {
            if (defaultValue === undefined) {
                throw new MissingKeyError(key);
            }
            return defaultValue;
        }
        let value = this.data[key];
        if (!Array.isArray(value)) {
            value = [value];
        }
        return value.map((node) => new DotAccessor(node));
    }
    value(key, type = 'string', defaultValue) {
        // let value = pick(xpath, this.data);
        const value = this.data[key];
        if (value === undefined) {
            if (arguments.length < 3) {
                throw new MissingKeyError(key);
            }
            return defaultValue;
        }
        return converteValueToType(value, type);
    }
    set(key, newValue) {
        this.data[key] = newValue;
    }
    flatMapping(input, mapping) {
        // tslint:disable-next-line: forin
        for (const inputPath in mapping) {
            const outputPath = mapping[inputPath];
            this.set(inputPath, input.value(outputPath));
        }
    }
    _assertHasKey(key) {
        if (!this.hasKey(key)) {
            throw new MissingKeyError(key);
        }
    }
    hasKey(key) {
        return key in this.data;
    }
}
